import styled from 'styled-components';

export const FlexAlignCenter = styled.div`
  display: flex;
  align-items: center;
`;

export const AttachmentHeaderWrap = styled(FlexAlignCenter)`
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 20px;
  display: ${({ hideHeader }) => hideHeader && 'none'};
`;

export const Title = styled.span`
  font-size: 14px;
  color: ${({ minView, theme }) => minView ? theme.colors.fontLightBlack : theme.colors.fontLightBlack};
`;

export const AttachmentsCount = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.fontSilver};
  
  &::before {
    margin-left: 5px;
    content: '';
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
`;

export const AttachmentHeaderContainer = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.greyMedium};
`;



// WEBPACK FOOTER //
// ./src/components/attachments/header/styled-components.js